import { experiment } from "@faire/web/common/settings/declarations/experiment";

/**
 * Logged Out Migrate Calls to Layout Service
 * Experiment for testing calling layout service for endpoints on the logged out discover and search pages
 */
export const FE_LO_MIGRATE_CALLS_TO_LAYOUT_SERVICE_250617 = experiment({
  name: "FE_LO_MIGRATE_CALLS_TO_LAYOUT_SERVICE_250617",
  identifier: "SessionToken",
  client: ["RETAILER", "VISITOR_WEB"],
  notifyAfter: "2025-08-22",
  defaultValue: false,
  productArea: "LOGGED_OUT_RETAILERS",
});
